export const convertToDateRange = (value) => ({
    dateFrom: value.periodDateFrom,
    dateTo: value.periodDateTo,
});
